(() => {
  const script = document.currentScript;
  const helpText = script?.dataset.commentHelp || 'Enter 5 to __IF_QUANTITY__ comments, one per line, without numbering.';
  const errorText = script?.dataset.invalidComments || 'Enter between 5 and __IF_QUANTITY__ comments, one per line.';
  const limits = {"796136781":10,"796137549":50,"796137761":100,"796138085":200,"796138409":500,"796138901":1000,"34388980685":10,"34389335565":50,"34390185805":100,"29466903478317":200,"35046419693733":500,"54873994363148":20,"54873995608332":30};
  const helpers = new WeakMap();
  let helperId = 0;
  const fields = () => document.querySelectorAll('textarea[name^="properties["]');
  const isComments = field => field instanceof HTMLTextAreaElement && /^properties\[/i.test(field.name) && /youtube/i.test(field.name) && /comments/i.test(field.name);
  const maxComments = field => {
    const variant = field.form?.elements.namedItem('id');
    return Number(limits[String(variant?.value || '')]) || 0;
  };
  const format = (text, max) => text.replace(/__IF_QUANTITY__|\{\{\s*quantity\s*\}\}/g, String(max));
  function update(field) {
    if (!isComments(field)) return;
    const max = maxComments(field);
    // Clear errors from the previous value/package before native form validation.
    field.setCustomValidity('');
    let helper = helpers.get(field);
    if (!max || field.disabled) {
      if (helper) helper.hidden = true;
      return;
    }
    if (!helper) {
      helper = document.createElement('p');
      helper.id = `youtube-comments-help-${++helperId}`;
      helper.style.cssText = 'font-size:12px;line-height:1.5;margin:6px 0;color:inherit;opacity:.8';
      field.insertAdjacentElement('afterend', helper);
      const describedBy = field.getAttribute('aria-describedby');
      field.setAttribute('aria-describedby', [describedBy, helper.id].filter(Boolean).join(' '));
      helpers.set(field, helper);
    }
    helper.hidden = false;
    const text = format(helpText, max);
    if (helper.textContent !== text) helper.textContent = text;
  }
  const refresh = () => fields().forEach(update);
  document.addEventListener('focusin', event => update(event.target), true);
  document.addEventListener('input', event => update(event.target), true);
  // Bubble after the package/variant handler has updated the form's variant ID.
  document.addEventListener('change', () => { refresh(); requestAnimationFrame(refresh); });
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('[data-package], variant-picker')) {
      refresh();
      requestAnimationFrame(refresh);
    }
  });
  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement)) return;
    for (const field of event.target.elements) {
      if (!isComments(field) || field.disabled) continue;
      const max = maxComments(field);
      if (!max) continue;
      const count = field.value.split(/\r\n|\r|\n/).filter(line => line.trim()).length;
      if (count < 5 || count > max) {
        event.preventDefault();
        event.stopImmediatePropagation();
        field.focus();
        field.setCustomValidity(format(errorText, max));
        field.reportValidity();
        return;
      }
      field.setCustomValidity('');
    }
  }, true);
  // Product forms can be replaced after a variant selection or opened in a dialog.
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches('textarea, form') || node.querySelector('textarea, form'))))) refresh();
  }).observe(document.documentElement, { childList: true, subtree: true });
  refresh();
})();
